import React from "react";

import AdminSectionShell from "../components/AdminSectionShell";
import ViewConfiguracoesHub from "../views/ViewConfiguracoesHub";
import { usePermissao } from "../uteis/permissaoAdm/usePermissao";

const GerenciarConfigSistema: React.FC = () => {
  const { isLoading, isValid } = usePermissao("ADM");

  if (isLoading) return <p>Verificando permissão...</p>;
  if (!isValid) return null;

  return (
    <AdminSectionShell backTo="/gerenciar">
      <ViewConfiguracoesHub />
    </AdminSectionShell>
  );
};

export default GerenciarConfigSistema;
